import { UuidProjectType } from 'core/userContext';
import { TestUserType } from './constants';

type TestUserConfig = {
  testUser: string;
  testUserType: TestUserType;
};

export const isUuidProjectWithNonUniqueEmails = (
  isUuidBased: boolean,
  uuidProjectType: UuidProjectType,
): boolean => {
  return isUuidBased && uuidProjectType === UuidProjectType.EmailNonUnique;
};

export const getTestUserConfig = (
  recipientEmail: string,
  userId: string,
  isUuidBased: boolean,
  uuidProjectType: UuidProjectType,
): TestUserConfig => {
  const isUuidProject = isUuidProjectWithNonUniqueEmails(isUuidBased, uuidProjectType);
  const testUser = (isUuidProject ? userId : recipientEmail) ?? '';
  const testUserType = isUuidProject ? TestUserType.UserId : TestUserType.Email;

  return {
    testUser,
    testUserType,
  };
};
